module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/handCare@3x_59d280.png";